<template>
  <header>
    <a href="https://www.asteaenergia.it"><img alt="Astea Energia" src="../assets/images/logo.svg"></a>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent"
}
</script>

<style scoped lang="scss">
header {
  padding-top: 16px;
  padding-bottom: 16px;

  img {
    height: 90px;
  }
}

@media (max-width: 767px) {
  header {
    padding-top: 0px;
    padding-bottom: 16px;

    img {
      height: 60px;
    }
  }
}
</style>